// import { gsap } from 'gsap';

if (document.querySelector('.text-sec__row-marquee')) {
  let currentScroll = window.pageYOffset;
  let isScrollingDown = true;
  let scrollTimeout;

  document.querySelectorAll('.text-sec__row-marquee').forEach((row) => {
    const track = row.querySelector('.text-sec__row-track');
    const content = track.querySelector('.text-sec__row-content');

    for (let i = 0; i < 10; i++) {
      const clone = content.cloneNode(true);
      track.appendChild(clone);
    }

    const contentWidth = content.offsetWidth;

    gsap.set(track, { x: -contentWidth });

    const tween = gsap.to(track, {
      x: `-=${contentWidth}`,
      duration: 80,
      ease: 'none',
      repeat: -1,
      modifiers: {
        x: gsap.utils.unitize((x) => parseFloat(x) % contentWidth),
      },
    });

    tween.totalProgress(0.5);

    /*window.addEventListener('scroll', () => {
      const newScroll = window.pageYOffset;
      isScrollingDown = newScroll > currentScroll;
      currentScroll = newScroll;

      gsap.to(tween, {
        timeScale: isScrollingDown ? 2 : -2,
        overwrite: true,
        duration: 0.2,
      });

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        gsap.to(tween, {
          timeScale: isScrollingDown ? 1 : -1,
          duration: 0.5,
          ease: 'power2.out',
        });
      }, 300);
    });*/
  });
}
